import { EColors } from "common/styles";
import { CopyRight } from "components/CopyRight";
import styled from "styled-components";

export const Link = styled.a`
  cursor: pointer;
  p {
    color: ${EColors.white};
    transition: all 0.3s linear;
  }
  text-decoration: none;

  &:hover p {
    color: ${EColors.accent_300};
  }
`;

export const PolicyPrivacyContainer = styled.div`
  display: flex;
  gap: 30px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }
`;

export const StyledCopyRight = styled(CopyRight)`
  align-self: center;
  @media screen and (max-width: 1000px) {
    display: flex;
  }
`;

export const StyledFooterBottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledPoliticsContent = styled.div`
  padding: 40px 16px;
  overflow-y: visible;
`;
